/**
 * Retorna um novo objeto contendo apenas as chaves presentes em `keysArr`
 * cujo valor original em `obj` é "truthy".
 *
 * Exemplo:
 * const obj = { a: 1, b: "", c: false, d: "ok" };
 * filterObjectByArray(obj, ["a", "b", "c", "d"]);
 * Resultado: { a: "1", d: "ok" }  // b e c são descartados por serem falsy
 *
 * @param obj Objeto base do qual serão extraídas as chaves. Deve ser um Record<string, string | number>.
 * @param keysArr Lista de chaves que se deseja filtrar (apenas essas serão consideradas).
 * @returns Novo objeto contendo apenas pares (chave: valor) truthy presentes em `obj` e referenciados em `keysArr`.
 */
export function filterTruthyObjectProperties(
  obj: Record<string, string | number>,
  keysArr: readonly string[]
): Record<string, string> {
  if (!obj) return {};
  const output: Record<string, string> = {};

  for (const key of keysArr) {
    const value = obj[key];

    if (value) {
      output[key] = String(value);
    }
  }

  return output;
}
